"use strict";
/* globals module */
/**
 * @module commerceProductFilesBatchRoute
 * @description Baasic Product Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic product Files Batch Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var CommerceProductFilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductFilesBatchRoute, _super);
    function CommerceProductFilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.unlinkRoute = 'commerce/product-files/batch/unlink';
        _this.updateRoute = 'commerce/product-files/batch';
        _this.linkRoute = 'commerce/product-files/batch/link';
        return _this;
    }
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @example CommerceProductFilesBatchRoute.unlink();
     **/
    CommerceProductFilesBatchRoute.prototype.unlink = function () {
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example CommerceProductFilesStreamsRoute.update();
     **/
    CommerceProductFilesBatchRoute.prototype.update = function () {
        return _super.prototype.baseCreate.call(this, this.updateRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example CommerceProductFilesStreamsRoute.link();
     **/
    CommerceProductFilesBatchRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    var _a;
    CommerceProductFilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceProductFilesBatchRoute);
    return CommerceProductFilesBatchRoute;
}(common_1.BaseRoute));
exports.CommerceProductFilesBatchRoute = CommerceProductFilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/
